import { useState, useEffect, useRef } from 'react'
import { cn } from '../../libs/utils'

import { MdKeyboardArrowDown } from 'react-icons/md'

export function Select({ list, onChange, name, option, placeholder = '', className }) {
	const [open, setOpen] = useState(false)
	const [item, setItem] = useState(null)

	const selectRef = useRef(null)

	useEffect(() => {
		const handleClickOutside = event => {
			if (selectRef.current && !selectRef.current.contains(event.target)) {
				setOpen(false)
			}
		}
		document.addEventListener('click', handleClickOutside)
		return () => {
			document.removeEventListener('click', handleClickOutside)
		}
	}, [])

	const handleClick = item => {
		setItem(item)
		onChange(item)
	}

	return (
		<div className={cn(className, 'tw-h-[42px] border tw-rounded-md tw-relative')} ref={selectRef} onClick={() => setOpen(!open)}>
			<div className={`tw-h-[42px] tw-flex tw-items-center tw-justify-between tw-px-2`}>
				<div>{option ? item?.value : <span className='tw-text-gray-400'>{placeholder}</span>}</div>
				<MdKeyboardArrowDown size={20} className={`tw-text-gray-500 tw-transition-all ${open ? 'tw-rotate-180' : 'tw-rotate-0'}`} />
			</div>

			{open && (
				<ul className='border tw-bg-white tw-shadow-md tw-list-none tw-rounded-sm tw-p-0 tw-absolute tw-w-full tw-top-[36px] tw-z-50'>
					{list.map(item => (
						<li key={item.id} onClick={() => handleClick(item)} className='tw-p-2 hover:tw-bg-purple-200 tw-cursor-pointer'>
							{item.value}
						</li>
					))}
				</ul>
			)}
		</div>
	)
}
